import { isNotDefined } from '@sgme/fp';
import { Box, HStack } from '@sgme/ui';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Fieldset } from '@/App/Blotter/grids/accumulator/details/Fieldset.tsx';
import { BlotterDrawerWrap } from '@/App/Blotter/grids/details/BlotterDrawerWrap.tsx';
import { StatusBadge } from '@/App/Blotter/grids/StatusBadge.tsx';
import { blotterSlice } from '@/store/blotter/slice.ts';
import { useAppSelector } from '@/store/hooks.ts';

type Props = { tradeId: string; className?: string; onClose?: () => void };

export const DetailsDrawer = ({ tradeId, className, onClose }: Props) => {
  const entry = useAppSelector((state) => blotterSlice.selectors.getAccumulatorEntryById(state, tradeId));

  const children = [] as ReactNode[];

  if (isNotDefined(entry)) {
    children.push(<div key="error">Accumulator trade id={tradeId} not found</div>);
  } else {
    children.push(
      <div key="productAndCurrency" className="display-5 mb-1 text-nowap">
        <FormattedMessage id={`blotter.tab.Accumulator.details.product.${entry.product}`} />
        &nbsp;
        {entry.currencyPair}
      </div>,
      <HStack key="idAndStatus" gap="8px" horizontalAlignment="start">
        <Box className="fw-bold">ID: {tradeId}</Box>
        <Box>
          <StatusBadge status={entry.status} />
        </Box>
      </HStack>,
      <div key="fieldset" className="h-100 overflow-y-auto overflow-x-hidden mt-2">
        <Fieldset entry={entry} />
      </div>,
    );
  }

  return (
    <BlotterDrawerWrap preventCloseButtonToHideContent className={className} onClose={onClose}>
      {children}
    </BlotterDrawerWrap>
  );
};
